"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchOnItemClicked = exports.watchOnMouseDown = exports.watchOnMouseUp = exports.watchOnResultEnquireClicked = exports.resultItemSagas = exports.getFavItemLoading = exports.getFilterType = exports.getCacheData = exports.getIsMapActive = exports.getResultItems = exports.getIsMapInit = exports.isFavLoading = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var myokay_map3_1 = require("@okay/myokay-map3");
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var RootSearchMapSaga_1 = require("@/pages/search/sagas/RootSearchMapSaga");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var WindowApi_1 = require("@/api/browser/WindowApi");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var Pages_1 = require("@/rendering/common/Pages");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var isDown = false;
exports.isFavLoading = function (state) { return state.results.isFavLoading; };
exports.getIsMapInit = function (state) { return state.mapsearch.mapInit; };
exports.getResultItems = function (state) { return state.results.resultResponses && state.results.resultResponses.length ? state.results.resultResponses[0].results : []; };
exports.getIsMapActive = function (state) { return state.mapsearch.viewport; };
exports.getCacheData = function (state) { return state.mapsearch.cacheData; };
exports.getFilterType = function (state) { return state.hfilter ? state.hfilter.listingType : SfilterTypeGroup_1.ListingPurposeType.Sale; };
exports.getFavItemLoading = function (state, id) {
    var reses = state.results.resultResponses;
    for (var i = 0; i < reses.length; i = i + 1) {
        var res = reses[i];
        var matchedItem = res.results.filter(function (it) { return Number(it.referenceId) === id; });
        if (!matchedItem.length)
            continue;
        return matchedItem[0].isSaving;
    }
};
var setInitIsSaved = function () {
    var savedPropertyIds, items, _i, items_1, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 1:
                savedPropertyIds = _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getResultItems)];
            case 2:
                items = _a.sent();
                _i = 0, items_1 = items;
                _a.label = 3;
            case 3:
                if (!(_i < items_1.length)) return [3 /*break*/, 7];
                item = items_1[_i];
                if (!(savedPropertyIds.indexOf(Number(item.referenceId)) >= 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setIsSaved(item.referenceId, true))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                ;
                _a.label = 6;
            case 6:
                _i++;
                return [3 /*break*/, 3];
            case 7: return [2 /*return*/];
        }
    });
};
var watchOnSliderInited = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_SLIDER_INITED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setSliderInited(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var setFavHintActive = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setFavHintActive(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(1000)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setFavHintActive(false))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnFavClicked = function () {
    var payload, item, isSaved;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_FAV_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(null))];
            case 2:
                _a.sent();
                item = payload;
                if (!item.isSaved) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.deleteSavedProperties, [Number(item.referenceId)])];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setIsSaved(item.referenceId, false))];
            case 4:
                _a.sent();
                return [3 /*break*/, 11];
            case 5: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(item))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addSavedProperties, [item])];
            case 7:
                isSaved = _a.sent();
                if (!isSaved) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setIsSaved(item.referenceId, true))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_property_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'sucessSaveProperty'))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setFavHintActive)];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchOnItemClicked = function () {
    var payload, property, lang, filterType, url, currentPage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                property = payload;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getFilterType)];
            case 3:
                filterType = _a.sent();
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, property.building, property.referenceId, SfilterTypeGroup_1.ListingPurposeType.toSfilterType(filterType))];
            case 4:
                url = _a.sent();
                return [4 /*yield*/, effects_1.select(RootSaga_1.getCurrentPage)];
            case 5:
                currentPage = _a.sent();
                if (!(currentPage === Pages_1.Pages.SEARCH)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.call(WindowApi_1.openTab, url)];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [3 /*break*/, 0];
            case 10: return [2 /*return*/];
        }
    });
};
exports.watchOnItemClicked = watchOnItemClicked;
var watchOnMouseUp = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_UP)];
            case 1:
                payload = (_a.sent()).payload;
                if (!isDown) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onItemClicked(payload))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.watchOnMouseUp = watchOnMouseUp;
var watchOnMouseHovering = function () {
    var payload, item, isMapActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_HOVERING)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.select(exports.getIsMapActive)];
            case 2:
                isMapActive = _a.sent();
                if (!isMapActive)
                    return [3 /*break*/, 0];
                if (!item.lat || !item.lng)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(RootSearchMapSaga_1.removeActivePins)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setExtraPins([{
                            lat: item.lat,
                            lng: item.lng,
                            title: '',
                            value: {
                                count: 1,
                                minPrice: item.price,
                                maxPrice: item.price,
                            },
                            type: myokay_map3_1.PinTypes.CALLOUT,
                            noCluster: true,
                        }]))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnMouseHoveringEnd = function () {
    var isMapActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_HOVERING_END)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getIsMapActive)];
            case 2:
                isMapActive = _a.sent();
                if (!isMapActive)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.setExtraPins([]))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnMouseEnter = function () {
    var payload, isHovering;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_ENTER)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.race({
                        isHovering: effects_1.delay(600),
                        hasAnotherEnter: effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_ENTER),
                        hasLeave: effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_LEAVE),
                    })];
            case 2:
                isHovering = (_a.sent()).isHovering;
                if (!isHovering) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onMouseHovering(payload))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnMouseLeave = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_LEAVE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onMouseHoveringEnd(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnMouseDown = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ITEM_MOUSE_DOWN)];
            case 1:
                _a.sent();
                isDown = true;
                setTimeout(function () { isDown = false; }, 140);
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
exports.watchOnMouseDown = watchOnMouseDown;
var watchOnResultEnquireClicked = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_ENQUIRE_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchOnResultEnquireClicked = watchOnResultEnquireClicked;
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setInitIsSaved)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchLogin = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setInitIsSaved)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var resultItemSagas = {
    watchOnSliderInited: watchOnSliderInited,
    watchOnResultEnquireClicked: watchOnResultEnquireClicked,
    watchOnFavClicked: watchOnFavClicked,
    watchOnMouseUp: watchOnMouseUp,
    watchOnMouseDown: watchOnMouseDown,
    watchOnMouseEnter: watchOnMouseEnter,
    watchOnMouseLeave: watchOnMouseLeave,
    watchOnMouseHovering: watchOnMouseHovering,
    watchOnMouseHoveringEnd: watchOnMouseHoveringEnd,
    watchOnItemClicked: watchOnItemClicked,
    watchInit: watchInit,
    watchLogin: watchLogin,
};
exports.resultItemSagas = resultItemSagas;
